import(/* webpackMode: "eager" */ "/workspace/apps/home-webapp/src/app/(pages)/insurance/egi/page.tsx");
